module.exports = __webpack_public_path__ + "static/media/team-4.237c2c5e.jpg";